import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '@/shared/api';

export type TokenRow = {
  token_hash: string
  created_at: Date | null
  token_alias: string | null
  clerk_user_id: string
  email?: string | null
  note?: string | null
  last_used_at?: Date | null
  expires_at?: Date | null
}

/** Hook for fetching tokens */
export function useTokens() {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['user-tokens'],
    queryFn: async () => {
      return apiClient<TokenRow[]>('/user-tokens')
    },
  })
}

/** Hook for creating token */
export function useCreateToken() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: { note?: string; expires_at?: string }) => {
      return apiClient<{ token: string }>('/user-tokens', {
        method: 'POST',
        body: JSON.stringify({
          note: params.note || undefined,
          expires_at: params.expires_at || undefined,
        }),
        headers: { 'Content-Type': 'application/json' },
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-tokens'] })
    },
  })
}

/** Hook for deleting token */
export function useDeleteToken() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (tokenHash: string) => {
      return apiClient<{ deleted: boolean }>(`/user-tokens/${tokenHash}`, {
        method: 'DELETE',
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-tokens'] })
    },
  })
}